import { render } from "./moh335.vue?vue&type=template&id=6ed87baa&scoped=true"
import script from "./moh335.vue?vue&type=script&lang=js"
export * from "./moh335.vue?vue&type=script&lang=js"

import "./moh335.vue?vue&type=style&index=0&id=6ed87baa&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed87baa"]])

export default __exports__